import { createRouter, createWebHistory } from "vue-router";

import RouterPath from "@/router/RouterPath";

let home = undefined as any
const routes = [] as any[]
const children = [] as any[]
const isProxy = window.eightcatty.cmd.indexOf("proxy") >= 0

const canPushToRoute = (route: any): boolean => {
  if (isProxy) {
    if (route.forProxy == true) {
      return true
    }
  } else {
    return true
  }
  return false
}

const loopRoutes = (result: Array<any>, children: Array<any>, route: any) => {
  if (route.path && route.path.length > 0) {
    const page = {
      path: route.path,
      name: route.name,
      meta: {
        requireAuth: route.requireAuth
      },
      component: route.component,
    } as any
    if (page.name === "Home") {
      home = page
    }
    if (route.props) {
      page.props = true
    }
    if (route.single) {
      if (canPushToRoute(route)) {
        if (isProxy && route.path == RouterPath.Recharge.Recharge.path) {
          page.path = "/"
          RouterPath.Recharge.Recharge.path = "/"
        }
        result.push(page)
      }
    } else {
      children.push(page)
    }
  } else {
    for (const key in route) {
      loopRoutes(result, children, (route as any)[key] as any)
    }
  }
}

loopRoutes(routes, children, RouterPath)

if (home) {
  home.children = children
  home.redirect = RouterPath.Common.Welcome.path
}

routes.push({
  path: "/:pathMatch(.*)",
  redirect: "/404"
})

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to: any, from: any, next: any) => {
  if (to.meta.requireAuth) {
    const token = localStorage.getItem("accessToken");
    if (token === "null" || token === "" || token === undefined || token === null) {
      next({
        path: RouterPath.Auth.SignIn.path,
        query: { redirect: encodeURIComponent(to.fullPath) }
      });
    } else {
      next()
    }
  } else {
    next()
  }
});

export default router;
